import ChangePasswordSuccess from 'features/myVaro/screens/PersonalDetails/ChangePasswordSuccess/ChangePasswordSuccess';
import React from 'react';

export default function ChangePasswordSuccessPage() {
  return <ChangePasswordSuccess />;
}
